import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5a2568eb = () => interopDefault(import('..\\pages\\exam\\index.vue' /* webpackChunkName: "pages/exam/index" */))
const _2b10de8b = () => interopDefault(import('..\\pages\\filling\\index.vue' /* webpackChunkName: "pages/filling/index" */))
const _7c419f9b = () => interopDefault(import('..\\pages\\index copy.vue' /* webpackChunkName: "pages/index copy" */))
const _569615ed = () => interopDefault(import('..\\pages\\index copy 2.vue' /* webpackChunkName: "pages/index copy 2" */))
const _685ddfde = () => interopDefault(import('..\\pages\\major\\index.vue' /* webpackChunkName: "pages/major/index" */))
const _6f0b71bf = () => interopDefault(import('..\\pages\\user\\index.vue' /* webpackChunkName: "pages/user/index" */))
const _bc28868c = () => interopDefault(import('..\\pages\\wiki\\index.vue' /* webpackChunkName: "pages/wiki/index" */))
const _fa4a77f0 = () => interopDefault(import('..\\pages\\exam\\detail.vue' /* webpackChunkName: "pages/exam/detail" */))
const _2725cff0 = () => interopDefault(import('..\\pages\\exam\\record.vue' /* webpackChunkName: "pages/exam/record" */))
const _69b8c846 = () => interopDefault(import('..\\pages\\exam\\wrong.vue' /* webpackChunkName: "pages/exam/wrong" */))
const _039e910d = () => interopDefault(import('..\\pages\\filling\\bookmark.vue' /* webpackChunkName: "pages/filling/bookmark" */))
const _38b6e622 = () => interopDefault(import('..\\pages\\filling\\catalogue.vue' /* webpackChunkName: "pages/filling/catalogue" */))
const _ef4e1b3a = () => interopDefault(import('..\\pages\\filling\\catalogue copy.vue' /* webpackChunkName: "pages/filling/catalogue copy" */))
const _bdb57eac = () => interopDefault(import('..\\pages\\filling\\diagnosis.vue' /* webpackChunkName: "pages/filling/diagnosis" */))
const _603271f9 = () => interopDefault(import('..\\pages\\filling\\down.vue' /* webpackChunkName: "pages/filling/down" */))
const _1b71bb10 = () => interopDefault(import('..\\pages\\filling\\filling.vue' /* webpackChunkName: "pages/filling/filling" */))
const _39d786ae = () => interopDefault(import('..\\pages\\filling\\researchDeatil.vue' /* webpackChunkName: "pages/filling/researchDeatil" */))
const _7b89cbb0 = () => interopDefault(import('..\\pages\\filling\\researchList.vue' /* webpackChunkName: "pages/filling/researchList" */))
const _81c0158c = () => interopDefault(import('..\\pages\\filling\\researchSearch.vue' /* webpackChunkName: "pages/filling/researchSearch" */))
const _051ff802 = () => interopDefault(import('..\\pages\\filling\\smart.vue' /* webpackChunkName: "pages/filling/smart" */))
const _6a760cc6 = () => interopDefault(import('..\\pages\\filling\\smartIm.vue' /* webpackChunkName: "pages/filling/smartIm" */))
const _60482f23 = () => interopDefault(import('..\\pages\\filling\\step.vue' /* webpackChunkName: "pages/filling/step" */))
const _36a7d8f2 = () => interopDefault(import('..\\pages\\filling\\table.vue' /* webpackChunkName: "pages/filling/table" */))
const _8185f382 = () => interopDefault(import('..\\pages\\filling\\tableAddMajor.vue' /* webpackChunkName: "pages/filling/tableAddMajor" */))
const _131c7456 = () => interopDefault(import('..\\pages\\filling\\tableInfo.vue' /* webpackChunkName: "pages/filling/tableInfo" */))
const _42748b78 = () => interopDefault(import('..\\pages\\login\\login.vue' /* webpackChunkName: "pages/login/login" */))
const _6b994efd = () => interopDefault(import('..\\pages\\login\\phone.vue' /* webpackChunkName: "pages/login/phone" */))
const _46a401a2 = () => interopDefault(import('..\\pages\\major\\detail.vue' /* webpackChunkName: "pages/major/detail" */))
const _36afb4a2 = () => interopDefault(import('..\\pages\\major\\list.vue' /* webpackChunkName: "pages/major/list" */))
const _4b81ae2d = () => interopDefault(import('..\\pages\\pageB\\carerrDetail.vue' /* webpackChunkName: "pages/pageB/carerrDetail" */))
const _e4e50e0c = () => interopDefault(import('..\\pages\\pageB\\carerrList.vue' /* webpackChunkName: "pages/pageB/carerrList" */))
const _70ec00f5 = () => interopDefault(import('..\\pages\\pageB\\carSpecialty.vue' /* webpackChunkName: "pages/pageB/carSpecialty" */))
const _25012774 = () => interopDefault(import('..\\pages\\pageB\\carSpecialtyMajor.vue' /* webpackChunkName: "pages/pageB/carSpecialtyMajor" */))
const _313cb451 = () => interopDefault(import('..\\pages\\pageB\\carSpecialtyMajor copy.vue' /* webpackChunkName: "pages/pageB/carSpecialtyMajor copy" */))
const _2b6f8f33 = () => interopDefault(import('..\\pages\\pageB\\developDetail.vue' /* webpackChunkName: "pages/pageB/developDetail" */))
const _4e7134f1 = () => interopDefault(import('..\\pages\\pageB\\developPage.vue' /* webpackChunkName: "pages/pageB/developPage" */))
const _264935cb = () => interopDefault(import('..\\pages\\pageB\\enrollmentRule.vue' /* webpackChunkName: "pages/pageB/enrollmentRule" */))
const _9ccf8b1a = () => interopDefault(import('..\\pages\\pageB\\evaList.vue' /* webpackChunkName: "pages/pageB/evaList" */))
const _411a9b4c = () => interopDefault(import('..\\pages\\pageB\\evaProblem.vue' /* webpackChunkName: "pages/pageB/evaProblem" */))
const _98de419c = () => interopDefault(import('..\\pages\\pageB\\evaResult.vue' /* webpackChunkName: "pages/pageB/evaResult" */))
const _2efc97f0 = () => interopDefault(import('..\\pages\\pageB\\evaResultList.vue' /* webpackChunkName: "pages/pageB/evaResultList" */))
const _309922e4 = () => interopDefault(import('..\\pages\\pageB\\filling.vue' /* webpackChunkName: "pages/pageB/filling" */))
const _4daab26e = () => interopDefault(import('..\\pages\\pageB\\industry.vue' /* webpackChunkName: "pages/pageB/industry" */))
const _485a61fa = () => interopDefault(import('..\\pages\\pageB\\industryDetail.vue' /* webpackChunkName: "pages/pageB/industryDetail" */))
const _2fc3c174 = () => interopDefault(import('..\\pages\\pageB\\luquRule.vue' /* webpackChunkName: "pages/pageB/luquRule" */))
const _2647ae0f = () => interopDefault(import('..\\pages\\pageB\\majorGoodSchool.vue' /* webpackChunkName: "pages/pageB/majorGoodSchool" */))
const _28f03a16 = () => interopDefault(import('..\\pages\\pageB\\majorTool.vue' /* webpackChunkName: "pages/pageB/majorTool" */))
const _0c80b5ff = () => interopDefault(import('..\\pages\\pageB\\organCompare.vue' /* webpackChunkName: "pages/pageB/organCompare" */))
const _ea4e3836 = () => interopDefault(import('..\\pages\\pageB\\organPage.vue' /* webpackChunkName: "pages/pageB/organPage" */))
const _747a857a = () => interopDefault(import('..\\pages\\pageB\\planPage.vue' /* webpackChunkName: "pages/pageB/planPage" */))
const _1fee295f = () => interopDefault(import('..\\pages\\pageB\\postSchool.vue' /* webpackChunkName: "pages/pageB/postSchool" */))
const _9acee4be = () => interopDefault(import('..\\pages\\pageB\\postSchoolPoint.vue' /* webpackChunkName: "pages/pageB/postSchoolPoint" */))
const _5a6cb24e = () => interopDefault(import('..\\pages\\pageB\\powerPage.vue' /* webpackChunkName: "pages/pageB/powerPage" */))
const _172210e7 = () => interopDefault(import('..\\pages\\pageB\\powerResult.vue' /* webpackChunkName: "pages/pageB/powerResult" */))
const _3f79bab7 = () => interopDefault(import('..\\pages\\pageB\\provinceRule.vue' /* webpackChunkName: "pages/pageB/provinceRule" */))
const _67a84332 = () => interopDefault(import('..\\pages\\pageB\\rule.vue' /* webpackChunkName: "pages/pageB/rule" */))
const _79dc469c = () => interopDefault(import('..\\pages\\pageB\\studioDetail.vue' /* webpackChunkName: "pages/pageB/studioDetail" */))
const _e41cf682 = () => interopDefault(import('..\\pages\\pageB\\studioList.vue' /* webpackChunkName: "pages/pageB/studioList" */))
const _859fc83e = () => interopDefault(import('..\\pages\\pageB\\volunChange.vue' /* webpackChunkName: "pages/pageB/volunChange" */))
const _036a0ff6 = () => interopDefault(import('..\\pages\\rank\\alumni-association.vue' /* webpackChunkName: "pages/rank/alumni-association" */))
const _98363980 = () => interopDefault(import('..\\pages\\rank\\comprehensive.vue' /* webpackChunkName: "pages/rank/comprehensive" */))
const _7c104ffc = () => interopDefault(import('..\\pages\\rank\\default-rank.vue' /* webpackChunkName: "pages/rank/default-rank" */))
const _4f309d0e = () => interopDefault(import('..\\pages\\school\\contrast.vue' /* webpackChunkName: "pages/school/contrast" */))
const _569207cc = () => interopDefault(import('..\\pages\\school\\contrastList.vue' /* webpackChunkName: "pages/school/contrastList" */))
const _014cba4b = () => interopDefault(import('..\\pages\\school\\contrastResult.vue' /* webpackChunkName: "pages/school/contrastResult" */))
const _0b4befdd = () => interopDefault(import('..\\pages\\school\\detail.vue' /* webpackChunkName: "pages/school/detail" */))
const _c08d8dd6 = () => interopDefault(import('..\\pages\\school\\examination.vue' /* webpackChunkName: "pages/school/examination" */))
const _71372f87 = () => interopDefault(import('..\\pages\\school\\forecast.vue' /* webpackChunkName: "pages/school/forecast" */))
const _d9fe59a8 = () => interopDefault(import('..\\pages\\school\\guarantee.vue' /* webpackChunkName: "pages/school/guarantee" */))
const _055c66aa = () => interopDefault(import('..\\pages\\school\\list.vue' /* webpackChunkName: "pages/school/list" */))
const _65d29951 = () => interopDefault(import('..\\pages\\school\\recommendDetail.vue' /* webpackChunkName: "pages/school/recommendDetail" */))
const _5c2752c2 = () => interopDefault(import('..\\pages\\school\\recommendDetailInfo.vue' /* webpackChunkName: "pages/school/recommendDetailInfo" */))
const _08a6dd1e = () => interopDefault(import('..\\pages\\school\\recommendList.vue' /* webpackChunkName: "pages/school/recommendList" */))
const _3a055d54 = () => interopDefault(import('..\\pages\\shop\\address.vue' /* webpackChunkName: "pages/shop/address" */))
const _2297acb2 = () => interopDefault(import('..\\pages\\shop\\address_info.vue' /* webpackChunkName: "pages/shop/address_info" */))
const _8e56764e = () => interopDefault(import('..\\pages\\shop\\create_order.vue' /* webpackChunkName: "pages/shop/create_order" */))
const _d4f47bf6 = () => interopDefault(import('..\\pages\\shop\\goods_info.vue' /* webpackChunkName: "pages/shop/goods_info" */))
const _49c0d416 = () => interopDefault(import('..\\pages\\shop\\goods_list.vue' /* webpackChunkName: "pages/shop/goods_list" */))
const _23a531b0 = () => interopDefault(import('..\\pages\\shop\\order_group.vue' /* webpackChunkName: "pages/shop/order_group" */))
const _88136de6 = () => interopDefault(import('..\\pages\\shop\\order_info.vue' /* webpackChunkName: "pages/shop/order_info" */))
const _01901cfd = () => interopDefault(import('..\\pages\\shop\\order_list.vue' /* webpackChunkName: "pages/shop/order_list" */))
const _882182d4 = () => interopDefault(import('..\\pages\\tools\\activationCode.vue' /* webpackChunkName: "pages/tools/activationCode" */))
const _6b574d90 = () => interopDefault(import('..\\pages\\tools\\baogao.vue' /* webpackChunkName: "pages/tools/baogao" */))
const _3870c214 = () => interopDefault(import('..\\pages\\tools\\baogaoList.vue' /* webpackChunkName: "pages/tools/baogaoList" */))
const _7c15ad17 = () => interopDefault(import('..\\pages\\tools\\batch.vue' /* webpackChunkName: "pages/tools/batch" */))
const _125b3e9f = () => interopDefault(import('..\\pages\\tools\\bindPage.vue' /* webpackChunkName: "pages/tools/bindPage" */))
const _cd63c892 = () => interopDefault(import('..\\pages\\tools\\browseLog.vue' /* webpackChunkName: "pages/tools/browseLog" */))
const _7accfb10 = () => interopDefault(import('..\\pages\\tools\\coinLog.vue' /* webpackChunkName: "pages/tools/coinLog" */))
const _0aca75e0 = () => interopDefault(import('..\\pages\\tools\\collectPlan.vue' /* webpackChunkName: "pages/tools/collectPlan" */))
const _40827fca = () => interopDefault(import('..\\pages\\tools\\collectSchool.vue' /* webpackChunkName: "pages/tools/collectSchool" */))
const _75c092ec = () => interopDefault(import('..\\pages\\tools\\configValue.vue' /* webpackChunkName: "pages/tools/configValue" */))
const _4aa53f8a = () => interopDefault(import('..\\pages\\tools\\contactUs.vue' /* webpackChunkName: "pages/tools/contactUs" */))
const _bcf404ce = () => interopDefault(import('..\\pages\\tools\\counter.vue' /* webpackChunkName: "pages/tools/counter" */))
const _bc604734 = () => interopDefault(import('..\\pages\\tools\\datas.vue' /* webpackChunkName: "pages/tools/datas" */))
const _03807d18 = () => interopDefault(import('..\\pages\\tools\\easterEgg.vue' /* webpackChunkName: "pages/tools/easterEgg" */))
const _e35f3d90 = () => interopDefault(import('..\\pages\\tools\\feedback.vue' /* webpackChunkName: "pages/tools/feedback" */))
const _447c5a85 = () => interopDefault(import('..\\pages\\tools\\general.vue' /* webpackChunkName: "pages/tools/general" */))
const _076d58b6 = () => interopDefault(import('..\\pages\\tools\\generalDetail.vue' /* webpackChunkName: "pages/tools/generalDetail" */))
const _4a9dd658 = () => interopDefault(import('..\\pages\\tools\\inviteLog.vue' /* webpackChunkName: "pages/tools/inviteLog" */))
const _ca428f64 = () => interopDefault(import('..\\pages\\tools\\kf.vue' /* webpackChunkName: "pages/tools/kf" */))
const _45d2a1f4 = () => interopDefault(import('..\\pages\\tools\\news.vue' /* webpackChunkName: "pages/tools/news" */))
const _77fc8877 = () => interopDefault(import('..\\pages\\tools\\newsDetail.vue' /* webpackChunkName: "pages/tools/newsDetail" */))
const _2dde593a = () => interopDefault(import('..\\pages\\tools\\province.vue' /* webpackChunkName: "pages/tools/province" */))
const _cd93c842 = () => interopDefault(import('..\\pages\\tools\\rank.vue' /* webpackChunkName: "pages/tools/rank" */))
const _59032e90 = () => interopDefault(import('..\\pages\\tools\\rankDetail.vue' /* webpackChunkName: "pages/tools/rankDetail" */))
const _1129b61d = () => interopDefault(import('..\\pages\\tools\\rankList.vue' /* webpackChunkName: "pages/tools/rankList" */))
const _77a307aa = () => interopDefault(import('..\\pages\\tools\\signUp.vue' /* webpackChunkName: "pages/tools/signUp" */))
const _2e692398 = () => interopDefault(import('..\\pages\\tools\\subsection.vue' /* webpackChunkName: "pages/tools/subsection" */))
const _65e4e065 = () => interopDefault(import('..\\pages\\tools\\subsection_bak.vue' /* webpackChunkName: "pages/tools/subsection_bak" */))
const _fc1470ee = () => interopDefault(import('..\\pages\\tools\\subsectionDetail.vue' /* webpackChunkName: "pages/tools/subsectionDetail" */))
const _05e061d8 = () => interopDefault(import('..\\pages\\tools\\video.vue' /* webpackChunkName: "pages/tools/video" */))
const _0f7cc1ba = () => interopDefault(import('..\\pages\\tools\\vip.vue' /* webpackChunkName: "pages/tools/vip" */))
const _4536d46a = () => interopDefault(import('..\\pages\\tools\\vip copy.vue' /* webpackChunkName: "pages/tools/vip copy" */))
const _3f99c230 = () => interopDefault(import('..\\pages\\tools\\vip2.vue' /* webpackChunkName: "pages/tools/vip2" */))
const _8fc2dfbe = () => interopDefault(import('..\\pages\\user\\addSchoolExam.vue' /* webpackChunkName: "pages/user/addSchoolExam" */))
const _4fa804a6 = () => interopDefault(import('..\\pages\\user\\edit.vue' /* webpackChunkName: "pages/user/edit" */))
const _560bd9f7 = () => interopDefault(import('..\\pages\\user\\editData.vue' /* webpackChunkName: "pages/user/editData" */))
const _26d47ffd = () => interopDefault(import('..\\pages\\user\\editProvince.vue' /* webpackChunkName: "pages/user/editProvince" */))
const _029dd215 = () => interopDefault(import('..\\pages\\user\\editScore.vue' /* webpackChunkName: "pages/user/editScore" */))
const _2c0d66d4 = () => interopDefault(import('..\\pages\\user\\schoolExam.vue' /* webpackChunkName: "pages/user/schoolExam" */))
const _7703feb3 = () => interopDefault(import('..\\pages\\school\\components\\AdmissionAnalysis.vue' /* webpackChunkName: "pages/school/components/AdmissionAnalysis" */))
const _2fe1b804 = () => interopDefault(import('..\\pages\\school\\components\\SchoolInfo.vue' /* webpackChunkName: "pages/school/components/SchoolInfo" */))
const _961df81a = () => interopDefault(import('..\\pages\\school\\components\\TongKao.vue' /* webpackChunkName: "pages/school/components/TongKao" */))
const _065aec28 = () => interopDefault(import('..\\pages\\school\\components\\XiaoKao.vue' /* webpackChunkName: "pages/school/components/XiaoKao" */))
const _7e74d5ea = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/exam",
    component: _5a2568eb,
    name: "exam"
  }, {
    path: "/filling",
    component: _2b10de8b,
    name: "filling"
  }, {
    path: "/index%20copy",
    component: _7c419f9b,
    name: "index copy"
  }, {
    path: "/index%20copy%202",
    component: _569615ed,
    name: "index copy 2"
  }, {
    path: "/major",
    component: _685ddfde,
    name: "major"
  }, {
    path: "/user",
    component: _6f0b71bf,
    name: "user"
  }, {
    path: "/wiki",
    component: _bc28868c,
    name: "wiki"
  }, {
    path: "/exam/detail",
    component: _fa4a77f0,
    name: "exam-detail"
  }, {
    path: "/exam/record",
    component: _2725cff0,
    name: "exam-record"
  }, {
    path: "/exam/wrong",
    component: _69b8c846,
    name: "exam-wrong"
  }, {
    path: "/filling/bookmark",
    component: _039e910d,
    name: "filling-bookmark"
  }, {
    path: "/filling/catalogue",
    component: _38b6e622,
    name: "filling-catalogue"
  }, {
    path: "/filling/catalogue%20copy",
    component: _ef4e1b3a,
    name: "filling-catalogue copy"
  }, {
    path: "/filling/diagnosis",
    component: _bdb57eac,
    name: "filling-diagnosis"
  }, {
    path: "/filling/down",
    component: _603271f9,
    name: "filling-down"
  }, {
    path: "/filling/filling",
    component: _1b71bb10,
    name: "filling-filling"
  }, {
    path: "/filling/researchDeatil",
    component: _39d786ae,
    name: "filling-researchDeatil"
  }, {
    path: "/filling/researchList",
    component: _7b89cbb0,
    name: "filling-researchList"
  }, {
    path: "/filling/researchSearch",
    component: _81c0158c,
    name: "filling-researchSearch"
  }, {
    path: "/filling/smart",
    component: _051ff802,
    name: "filling-smart"
  }, {
    path: "/filling/smartIm",
    component: _6a760cc6,
    name: "filling-smartIm"
  }, {
    path: "/filling/step",
    component: _60482f23,
    name: "filling-step"
  }, {
    path: "/filling/table",
    component: _36a7d8f2,
    name: "filling-table"
  }, {
    path: "/filling/tableAddMajor",
    component: _8185f382,
    name: "filling-tableAddMajor"
  }, {
    path: "/filling/tableInfo",
    component: _131c7456,
    name: "filling-tableInfo"
  }, {
    path: "/login/login",
    component: _42748b78,
    name: "login-login"
  }, {
    path: "/login/phone",
    component: _6b994efd,
    name: "login-phone"
  }, {
    path: "/major/detail",
    component: _46a401a2,
    name: "major-detail"
  }, {
    path: "/major/list",
    component: _36afb4a2,
    name: "major-list"
  }, {
    path: "/pageB/carerrDetail",
    component: _4b81ae2d,
    name: "pageB-carerrDetail"
  }, {
    path: "/pageB/carerrList",
    component: _e4e50e0c,
    name: "pageB-carerrList"
  }, {
    path: "/pageB/carSpecialty",
    component: _70ec00f5,
    name: "pageB-carSpecialty"
  }, {
    path: "/pageB/carSpecialtyMajor",
    component: _25012774,
    name: "pageB-carSpecialtyMajor"
  }, {
    path: "/pageB/carSpecialtyMajor%20copy",
    component: _313cb451,
    name: "pageB-carSpecialtyMajor copy"
  }, {
    path: "/pageB/developDetail",
    component: _2b6f8f33,
    name: "pageB-developDetail"
  }, {
    path: "/pageB/developPage",
    component: _4e7134f1,
    name: "pageB-developPage"
  }, {
    path: "/pageB/enrollmentRule",
    component: _264935cb,
    name: "pageB-enrollmentRule"
  }, {
    path: "/pageB/evaList",
    component: _9ccf8b1a,
    name: "pageB-evaList"
  }, {
    path: "/pageB/evaProblem",
    component: _411a9b4c,
    name: "pageB-evaProblem"
  }, {
    path: "/pageB/evaResult",
    component: _98de419c,
    name: "pageB-evaResult"
  }, {
    path: "/pageB/evaResultList",
    component: _2efc97f0,
    name: "pageB-evaResultList"
  }, {
    path: "/pageB/filling",
    component: _309922e4,
    name: "pageB-filling"
  }, {
    path: "/pageB/industry",
    component: _4daab26e,
    name: "pageB-industry"
  }, {
    path: "/pageB/industryDetail",
    component: _485a61fa,
    name: "pageB-industryDetail"
  }, {
    path: "/pageB/luquRule",
    component: _2fc3c174,
    name: "pageB-luquRule"
  }, {
    path: "/pageB/majorGoodSchool",
    component: _2647ae0f,
    name: "pageB-majorGoodSchool"
  }, {
    path: "/pageB/majorTool",
    component: _28f03a16,
    name: "pageB-majorTool"
  }, {
    path: "/pageB/organCompare",
    component: _0c80b5ff,
    name: "pageB-organCompare"
  }, {
    path: "/pageB/organPage",
    component: _ea4e3836,
    name: "pageB-organPage"
  }, {
    path: "/pageB/planPage",
    component: _747a857a,
    name: "pageB-planPage"
  }, {
    path: "/pageB/postSchool",
    component: _1fee295f,
    name: "pageB-postSchool"
  }, {
    path: "/pageB/postSchoolPoint",
    component: _9acee4be,
    name: "pageB-postSchoolPoint"
  }, {
    path: "/pageB/powerPage",
    component: _5a6cb24e,
    name: "pageB-powerPage"
  }, {
    path: "/pageB/powerResult",
    component: _172210e7,
    name: "pageB-powerResult"
  }, {
    path: "/pageB/provinceRule",
    component: _3f79bab7,
    name: "pageB-provinceRule"
  }, {
    path: "/pageB/rule",
    component: _67a84332,
    name: "pageB-rule"
  }, {
    path: "/pageB/studioDetail",
    component: _79dc469c,
    name: "pageB-studioDetail"
  }, {
    path: "/pageB/studioList",
    component: _e41cf682,
    name: "pageB-studioList"
  }, {
    path: "/pageB/volunChange",
    component: _859fc83e,
    name: "pageB-volunChange"
  }, {
    path: "/rank/alumni-association",
    component: _036a0ff6,
    name: "rank-alumni-association"
  }, {
    path: "/rank/comprehensive",
    component: _98363980,
    name: "rank-comprehensive"
  }, {
    path: "/rank/default-rank",
    component: _7c104ffc,
    name: "rank-default-rank"
  }, {
    path: "/school/contrast",
    component: _4f309d0e,
    name: "school-contrast"
  }, {
    path: "/school/contrastList",
    component: _569207cc,
    name: "school-contrastList"
  }, {
    path: "/school/contrastResult",
    component: _014cba4b,
    name: "school-contrastResult"
  }, {
    path: "/school/detail",
    component: _0b4befdd,
    name: "school-detail"
  }, {
    path: "/school/examination",
    component: _c08d8dd6,
    name: "school-examination"
  }, {
    path: "/school/forecast",
    component: _71372f87,
    name: "school-forecast"
  }, {
    path: "/school/guarantee",
    component: _d9fe59a8,
    name: "school-guarantee"
  }, {
    path: "/school/list",
    component: _055c66aa,
    name: "school-list"
  }, {
    path: "/school/recommendDetail",
    component: _65d29951,
    name: "school-recommendDetail"
  }, {
    path: "/school/recommendDetailInfo",
    component: _5c2752c2,
    name: "school-recommendDetailInfo"
  }, {
    path: "/school/recommendList",
    component: _08a6dd1e,
    name: "school-recommendList"
  }, {
    path: "/shop/address",
    component: _3a055d54,
    name: "shop-address"
  }, {
    path: "/shop/address_info",
    component: _2297acb2,
    name: "shop-address_info"
  }, {
    path: "/shop/create_order",
    component: _8e56764e,
    name: "shop-create_order"
  }, {
    path: "/shop/goods_info",
    component: _d4f47bf6,
    name: "shop-goods_info"
  }, {
    path: "/shop/goods_list",
    component: _49c0d416,
    name: "shop-goods_list"
  }, {
    path: "/shop/order_group",
    component: _23a531b0,
    name: "shop-order_group"
  }, {
    path: "/shop/order_info",
    component: _88136de6,
    name: "shop-order_info"
  }, {
    path: "/shop/order_list",
    component: _01901cfd,
    name: "shop-order_list"
  }, {
    path: "/tools/activationCode",
    component: _882182d4,
    name: "tools-activationCode"
  }, {
    path: "/tools/baogao",
    component: _6b574d90,
    name: "tools-baogao"
  }, {
    path: "/tools/baogaoList",
    component: _3870c214,
    name: "tools-baogaoList"
  }, {
    path: "/tools/batch",
    component: _7c15ad17,
    name: "tools-batch"
  }, {
    path: "/tools/bindPage",
    component: _125b3e9f,
    name: "tools-bindPage"
  }, {
    path: "/tools/browseLog",
    component: _cd63c892,
    name: "tools-browseLog"
  }, {
    path: "/tools/coinLog",
    component: _7accfb10,
    name: "tools-coinLog"
  }, {
    path: "/tools/collectPlan",
    component: _0aca75e0,
    name: "tools-collectPlan"
  }, {
    path: "/tools/collectSchool",
    component: _40827fca,
    name: "tools-collectSchool"
  }, {
    path: "/tools/configValue",
    component: _75c092ec,
    name: "tools-configValue"
  }, {
    path: "/tools/contactUs",
    component: _4aa53f8a,
    name: "tools-contactUs"
  }, {
    path: "/tools/counter",
    component: _bcf404ce,
    name: "tools-counter"
  }, {
    path: "/tools/datas",
    component: _bc604734,
    name: "tools-datas"
  }, {
    path: "/tools/easterEgg",
    component: _03807d18,
    name: "tools-easterEgg"
  }, {
    path: "/tools/feedback",
    component: _e35f3d90,
    name: "tools-feedback"
  }, {
    path: "/tools/general",
    component: _447c5a85,
    name: "tools-general"
  }, {
    path: "/tools/generalDetail",
    component: _076d58b6,
    name: "tools-generalDetail"
  }, {
    path: "/tools/inviteLog",
    component: _4a9dd658,
    name: "tools-inviteLog"
  }, {
    path: "/tools/kf",
    component: _ca428f64,
    name: "tools-kf"
  }, {
    path: "/tools/news",
    component: _45d2a1f4,
    name: "tools-news"
  }, {
    path: "/tools/newsDetail",
    component: _77fc8877,
    name: "tools-newsDetail"
  }, {
    path: "/tools/province",
    component: _2dde593a,
    name: "tools-province"
  }, {
    path: "/tools/rank",
    component: _cd93c842,
    name: "tools-rank"
  }, {
    path: "/tools/rankDetail",
    component: _59032e90,
    name: "tools-rankDetail"
  }, {
    path: "/tools/rankList",
    component: _1129b61d,
    name: "tools-rankList"
  }, {
    path: "/tools/signUp",
    component: _77a307aa,
    name: "tools-signUp"
  }, {
    path: "/tools/subsection",
    component: _2e692398,
    name: "tools-subsection"
  }, {
    path: "/tools/subsection_bak",
    component: _65e4e065,
    name: "tools-subsection_bak"
  }, {
    path: "/tools/subsectionDetail",
    component: _fc1470ee,
    name: "tools-subsectionDetail"
  }, {
    path: "/tools/video",
    component: _05e061d8,
    name: "tools-video"
  }, {
    path: "/tools/vip",
    component: _0f7cc1ba,
    name: "tools-vip"
  }, {
    path: "/tools/vip%20copy",
    component: _4536d46a,
    name: "tools-vip copy"
  }, {
    path: "/tools/vip2",
    component: _3f99c230,
    name: "tools-vip2"
  }, {
    path: "/user/addSchoolExam",
    component: _8fc2dfbe,
    name: "user-addSchoolExam"
  }, {
    path: "/user/edit",
    component: _4fa804a6,
    name: "user-edit"
  }, {
    path: "/user/editData",
    component: _560bd9f7,
    name: "user-editData"
  }, {
    path: "/user/editProvince",
    component: _26d47ffd,
    name: "user-editProvince"
  }, {
    path: "/user/editScore",
    component: _029dd215,
    name: "user-editScore"
  }, {
    path: "/user/schoolExam",
    component: _2c0d66d4,
    name: "user-schoolExam"
  }, {
    path: "/school/components/AdmissionAnalysis",
    component: _7703feb3,
    name: "school-components-AdmissionAnalysis"
  }, {
    path: "/school/components/SchoolInfo",
    component: _2fe1b804,
    name: "school-components-SchoolInfo"
  }, {
    path: "/school/components/TongKao",
    component: _961df81a,
    name: "school-components-TongKao"
  }, {
    path: "/school/components/XiaoKao",
    component: _065aec28,
    name: "school-components-XiaoKao"
  }, {
    path: "/",
    component: _7e74d5ea,
    name: "index"
  }, {
    path: "/generalinfo/:id/",
    component: _076d58b6,
    name: "generalinfo"
  }, {
    path: "/information/:id/",
    component: _77fc8877,
    name: "information"
  }, {
    path: "/informationlist/:type/",
    component: _45d2a1f4,
    name: "informationlist"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
